module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-ties.ee0671ac.png";